import React, { useRef, useState } from 'react';
import i18n from "../../i18n";
import { AVAILABLE_LOCALES } from '../../constants'
import { makeStyles } from "@material-ui/styles";

import {
    ClickAwayListener,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Paper,
    Popper,
    Typography
} from '@material-ui/core';

import { Language as LanguageIcon, Check as CheckIcon } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLocations } from 'actions/Location/listAction';

const useStyles = makeStyles(theme => ({
    root: {
        marginLeft: 'auto',
        order: 2,
    },
    localeBlock: {
        ...theme.typography.button,
        marginLeft: theme.spacing(1),
        color: theme.palette.white,
    },
    localeLabel: {
    },
    localeIcon: {
        color: theme.palette.white,
    },
    popper: {
        zIndex: theme.zIndex.appBar + 100
    },
    popperContent: {
        marginTop: theme.spacing(1)
    },
}));

const LocaleSelector = props => {
    const { className, ...rest } = props;
    const classes = useStyles();
    const moreRef = useRef(null);
    const currentLocale = AVAILABLE_LOCALES.find(al => al.locale === i18n.language);
    const [openPopper, setOpenPopper] = useState(false);
    const dispatch = useDispatch();
    const locationsFetched = useSelector(store => !!(store.locations && store.locations.isFetched));

    const onLocaleChange = (e, locale)=> {
        i18n.changeLanguage(locale);
        // PLACE NAMES are translated by the server (Gedmo, Accept-Language)
        // and were fetched in the old language: read them again in the new
        // one (18 Oct 2026: «При переключенні мови, назви локацій не
        // змінилися»). The request goes out after changeLanguage, so it
        // carries the new Accept-Language.
        if (locationsFetched) {
            dispatch(fetchLocations());
        }
        handlePopperClose();
    }

    const handlePopoverOpen = () => {
        setOpenPopper(true);
    };

    const handlePopperClose = () => {
        setOpenPopper(false);
    };

    return (<div className={classes.root}>
        <Typography
            onMouseEnter={handlePopoverOpen}
            onClick={handlePopoverOpen}
            className={classes.localeBlock}
        >
            <span className={classes.localeLabel}>{currentLocale.label}</span>
            <IconButton
                {...rest}
                ref={moreRef}
                size="small"
                className={classes.localeIcon}
            >
                <LanguageIcon />
            </IconButton>
        </Typography>
        <Popper
            anchorEl={moreRef.current}
            className={classes.popper}
            open={openPopper}
            transition
        >
            <ClickAwayListener onClickAway={handlePopperClose}>
                <Paper
                    className={classes.popperContent}
                    elevation={3}
                >
                    <List>
                        {AVAILABLE_LOCALES.map(l => (
                            <ListItem
                                button
                                key={l.locale}
                                onClick={e => onLocaleChange(e, l.locale)}
                            >
                                <ListItemIcon>
                                    {currentLocale.locale === l.locale && <CheckIcon />}
                                </ListItemIcon>
                                <ListItemText primary={l.label} />
                            </ListItem>
                        ))}
                    </List>
                </Paper>
            </ClickAwayListener>
        </Popper>
    </div>);
}

export default LocaleSelector;